import { createStore } from 'vuex'

export default createStore({
  state: {
    weburl:"https://tts.indoorlink.com/",
    srcurl:"https://tts.indoorlink.com/static/",        //资源路径
    speakerList:[],          //扬声器列表
    speakerListLoading:false, //扬声器列表加载状态
    userInfo:{},            //用户信息
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
